import React from 'react';

import { Box, Typography } from '@mui/material';

import { PageInformationContext } from '@/context/PageInformationContext';
import type { MarketApp } from '@/features/Dashboard/types';
import { useMarketPreview } from '@/hooks/api/market';
import MarketsComponents from '@/pages/Markets/MarketsComponents';
import { MarketWidgetSkeleton } from '@/pages/Markets/MarketsSkeleton/MarketWidgetSkeleton';

export const Preview = ({
  template,
  enabled = true
}: {
  template: MarketApp | undefined;
  enabled?: boolean;
}) => {
  const { data, isRefetching } = useMarketPreview(template ? [template] : undefined, enabled);
  return (
    <PageInformationContext value={{ mainPageTitle: 'Dashboard' }}>
      <Box
        sx={{
          backgroundColor: 'gx.tileLight',
          display: 'flex',
          flex: 1,
          flexDirection: 'column',
          p: 2,
          '.apps__container': {
            display: 'flex',
            flexDirection: 'column',
            gap: 2
          },
          '.highlighted-prices__container': {
            gap: 2,
            flexDirection: 'column',
            flexWrap: 'nowrap'
          }
        }}
      >
        <Typography
          className='label__container'
          sx={{
            fontWeight: 700,
            fontSize: 14,
            mb: enabled ? 1 : 0
          }}
        >
          Preview
        </Typography>

        {isRefetching && (
          <Box sx={{ '.MuiPaper-root': { width: '100%', height: '100%' } }}>
            <MarketWidgetSkeleton />
          </Box>
        )}
        {!isRefetching && data && (
          <Box
            sx={{
              pointerEvents: 'none',
              userSelect: 'none'
            }}
          >
            <MarketsComponents
              components={data.components}
              showAddToDashboard={false}
              showShareBlock={false}
            />
          </Box>
        )}
      </Box>
    </PageInformationContext>
  );
};
